import { Navigate, Outlet } from 'react-router-dom';
import { useBlindSignupToken, useSession } from '../hooks';
import { Login } from '../views';

interface NotLoggedRoutesProps {
  isLoginWithToken: boolean;
}

const NotLoggedRoutes = ({ isLoginWithToken }: NotLoggedRoutesProps) => {
  const { isUserLogged } = useSession();
  useBlindSignupToken();

  return <>{isLoginWithToken ? <Login /> : !isUserLogged ? <Outlet /> : <Navigate to={'/personas'} />}</>;
};

export default NotLoggedRoutes;
